var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-footer" }, [
    _c("div", { staticClass: "footer-more flex" }, [
      _c(
        "div",
        { staticClass: "flex-1 privacy" },
        [
          _c("shield-icon"),
          _vm._v(" "),
          _c("a", { attrs: { href: _vm.privacyPolicy, target: "_blank" } }, [
            _vm._v("Privacy policy"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-1 powered" },
        [
          _c("span", [_vm._v("Powered")]),
          _vm._v(" "),
          _c("bot-icon"),
          _vm._v(" "),
          _c("span", [_vm._v("by")]),
          _vm._v(" "),
          _vm.chatchampLinkClickable
            ? _c(
                "a",
                {
                  staticClass: "footer-more__powered-by-link",
                  attrs: { href: _vm.poweredByURL, target: "_blank" },
                },
                [_vm._v("trbo")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.chatchampLinkClickable ? _c("span", [_vm._v("trbo")]) : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }